import React from "react";
import * as moment from "moment";
import UserDefaultAvatar from "assets/img/user.svg";
import { useHistory } from "react-router-dom";
import LazyLoadImage from "components/LazyLoadImage";

export default ({ netThriving }) => {
  let history = useHistory();

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  const calculateTimeDifferenceFull = (endDate) => {
    var now = moment(new Date());
    var then = moment(endDate);

    var ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(
      moment(then, "DD/MM/YYYY HH:mm:ss")
    );
    var d = moment.duration(ms);
    var monthsFull = d._data.months;
    var daysFull = d._data.days;
    var yearsFull = d._data.years;

    var finalDate = [
      {
        key: yearsFull,
        value: "Y",
      },
      {
        key: monthsFull,
        value: "M",
      },
      {
        key: daysFull,
        value: "D",
      },
    ];

    var result = finalDate
      .filter((date) => date.key !== 0)
      .map((date) => `${date.key}${date.value} `);

    if (result.length === 0) {
      return "N/A";
    }

    return result.join("");
  };

  return netThriving?.map((userStats) => (
    <div key={userStats?.id} className="setThrivingScore">
      <div className="ntsdetailinfogrid">
        <div className="username">{userStats.full_name}</div>
        <div className="ntsdetailinfocontainer">
          <p className="ntsdetailinfodiv">
            <span
              style={{ color: "White", fontSize: "13px", fontWeight: "400" }}
            >
              Net Thriving Score:
            </span>
            <span className="detailvalue">
              {userStats.profile.net_thriving_score}
            </span>
          </p>
          <p className="ntsdetailinfodiv">
            <span
              style={{ color: "White", fontSize: "13px", fontWeight: "400" }}
            >
              Happiness Meter:
            </span>
            <span className="detailvalue">{userStats.happiness_meter}%</span>
          </p>
          <p className="ntsdetailinfodiv">
            <span
              style={{ color: "White", fontSize: "13px", fontWeight: "400" }}
            >
              Last Post Created:
            </span>
            <span className="detailvalue">
              {!moment(userStats?.last_post_created).isValid()
                ? "N/A"
                : moment(userStats?.last_post_created).format("MMM D, YYYY")}
            </span>
          </p>
          <p className="ntsdetailinfodiv">
            <span
              style={{ color: "White", fontSize: "13px", fontWeight: "400" }}
            >
              Length with company:
            </span>
            <span className="detailvalue">
              {calculateTimeDifferenceFull(
                moment(userStats?.profile?.company_joined).format("YYYY MMM DD")
              )}
            </span>
          </p>
          <p className="ntsdetailinfodiv">
            <span
              style={{ color: "White", fontSize: "13px", fontWeight: "400" }}
            >
              Length with Team:
            </span>
            <span className="detailvalue">
              {calculateTimeDifferenceFull(moment(userStats?.team_joined))}
            </span>
          </p>
          <p className="ntsdetailinfodiv">
            <span
              style={{ color: "White", fontSize: "13px", fontWeight: "400" }}
            >
              Length with ReTeam:
            </span>
            <span className="detailvalue">
              {calculateTimeDifferenceFull(
                moment(userStats?.created_at).format("YYYY MMM DD")
              )}
            </span>
          </p>
        </div>
      </div>
      <div className="ntsdetailinfogridright">
        <div>
          <span key={userStats.id}>
            <LazyLoadImage
              onClickFunction={() => showUserProfile(userStats?.id)}
              style={{
                width: "55px",
                height: "55px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "10px",
                cursor: "pointer",
              }}
              image={userStats.avatar ?? UserDefaultAvatar}
              key={userStats.full_name}
              alt={userStats.full_name}
              title={userStats.full_name || ""}
            />
          </span>
        </div>
        <div>
          <div className="strengths">Strengths</div>
          <div className="userStrengths">
            {userStats?.strengths.map((strength) => (
              <span key={strength?.id} className="userStrengthName">
                {strength.name}
              </span>
            ))}
            {userStats?.strengths?.length === 0 && (
              <span className="userStrengthName">N/A</span>
            )}
          </div>
        </div>
      </div>
    </div>
  ));
};
